import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.DEV ? 'development' : 'production',
    release: `console@${__APP_VERSION__}`,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    ignoreErrors: ['ResizeObserver loop', 'Non-Error promise rejection', /Loading chunk \d+ failed/],
    beforeSend(event) {
        // Strip potential PII from breadcrumbs (player email, phone)
        if (event.breadcrumbs) {
            event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
                if (breadcrumb.data) {
                    delete breadcrumb.data.email;
                    delete breadcrumb.data.phone;
                }
                return breadcrumb;
            });
        }
        return event;
    },
});

// import React from 'react';
import ReactDOM from 'react-dom/client';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { TRANSLATIONS, DEFAULT_LANGUAGE } from './config/translations/translations';

import App from './App';
import { captureAttribution } from './utils/attribution';

import './font.css';
import './index.css';
import './App.css';
import './styles/redesign-tokens.css';

i18n.use(XHR)
    .use(initReactI18next)
    .use(LanguageDetector) // passes i18n down to react-i18next
    .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        detection: { order: ['navigator'], caches: [] },
        resources: TRANSLATIONS,
        // lng: DEFAULT_LANGUAGE, // if you're using a language detector, do not define the lng option
        fallbackLng: DEFAULT_LANGUAGE,
        interpolation: {
            escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
    });

// `<html lang>` doit refléter la langue réellement affichée. Une page déclarée
// `en` mais remplie de français déclenche la traduction automatique de Chrome :
// le traducteur emballe chaque texte dans des <font>, React ne retrouve plus les
// nœuds qu'il a posés et plante (`insertBefore ... is not a child of this node`).
// On lit la langue *résolue* et non celle demandée : une langue non supportée
// retombe sur `fallbackLng`, et c'est celle-là qui est réellement affichée.
// Seul endroit de l'app qui écrit `<html lang>`. Cf gotcha #153.
const syncHtmlLang = () => {
    const [base] = (i18n.resolvedLanguage || DEFAULT_LANGUAGE).split('-');
    document.documentElement.lang = base;
};
i18n.on('languageChanged', syncHtmlLang);
i18n.on('initialized', syncHtmlLang);
syncHtmlLang();

// Avant le render : le router peut réécrire l'URL (redirects) et perdre la query
captureAttribution();

ReactDOM.createRoot(document.getElementById('root')!).render(
    //     <React.StrictMode>
    <App />
    // </React.StrictMode>
);
